import React from 'react';
import { AutosuggestDropdown } from 'framework/form';
import SearchIcon from '@mui/icons-material/SearchOutlined';
import { useCandidateService, useCandidateUrl } from 'domain/shared/candidate';
import { openPageInNewTab } from 'framework/utils';

const HeaderSearchCandidateSelect = () => {
  const { getSingleEntityUrl } = useCandidateUrl();
  const { search } = useCandidateService();

  return (
    <AutosuggestDropdown
      isInfinityLoading
      source="search"
      loadSuggestionsMethod={async (text: string, loadCurrentPage: number) => {
        const response = await search({
          pageSize: 30,
          pageNumber: loadCurrentPage,
          filter: {
            searchString: {
              ct: text,
            },
          },
          sort: {
            status: 'DESC',
          },
        });

        return response;
      }}
      mapResults={item => {
        return {
          id: item.id,
          text: item.name.fullName,
        };
      }}
      selectSuggestionMethod={value => {
        if (value) {
          openPageInNewTab(getSingleEntityUrl(value));
        }
      }}
      sx={{
        '&&': {
          marginBottom: 0,
          color: 'text.primary',
          minWidth: '242px',
          '& input.autosuggestion-dropdown__input': {
            fontSize: '12px',
            paddingLeft: '25px',
          },
          '& .floating-base-input-label': {
            paddingLeft: '10px',
            fontSize: '12px',
          },
        },
      }}
      placeholder="Search candidate by ID, email, name"
      InputIcon={
        <SearchIcon
          sx={(theme: any) => ({
            position: 'absolute',
            zIndex: 10,
            width: '20px',
            top: '5px',
            left: '5px',
            color: theme.vars.palette.primary.main,
          })}
        />
      }
      searchRequest={search}
    />
  );
};

export default HeaderSearchCandidateSelect;

// const [value, setValue] = useState('');
